import { render, staticRenderFns } from "./hospitaldetails.vue?vue&type=template&id=aac29c02"
import script from "./hospitaldetails.vue?vue&type=script&lang=js"
export * from "./hospitaldetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports